/* eslint-disable @typescript-eslint/no-explicit-any */
const getClientDeviceInfo = (): {
	appName: string;
	appVersion: string;
	deviceName: string;
	deviceModel: string;
	deviceFirmware: string;
	userAgent: string;
} => {
	const userAgent = navigator.userAgent;
	const platform = navigator.platform || "unknown";

	// User-Agent data API (only in Chromium-based browsers)
	let deviceModel = "unknown";
	if ((navigator as any).userAgentData?.brands?.length) {
		deviceModel = (navigator as any).userAgentData.brands
			.map((b: any) => b.brand)
			.join(" ");
	} else {
		deviceModel = userAgent.includes("iPhone")
			? "iPhone"
			: userAgent.includes("Android")
				? "Android"
				: userAgent.includes("Mac")
					? "Mac"
					: userAgent.includes("Windows")
						? "Windows"
						: "Browser";
	}

	return {
		userAgent,
		appName: "Tex Web", // static and consistent
		appVersion: "1.0.0", // version of your web app
		deviceName: navigator.vendor || "unknown",
		deviceModel,
		deviceFirmware: platform,
	};
};

export default getClientDeviceInfo;
